import { API, graphqlOperation } from "aws-amplify";
import handleError from "../../errorHandler";
import { GET_COUNTRIES_LIST, GET_COUNTRIES_LIST_SUCCESS, GET_COUNTRIES_LIST_FAILURE, TRIGGER_TOAST } from "../constants";
import { GetCountriesList } from "./../../queries";

const getCountriesList = () => {
  return async (dispatch: any) => {
    dispatch({ type: GET_COUNTRIES_LIST });
    const countriesListHandle = API.graphql(graphqlOperation(GetCountriesList)) as Promise<any>;
    countriesListHandle
      .then(async (countriesListData: any) => {
        if (countriesListData && countriesListData.data) {
          dispatch({ type: GET_COUNTRIES_LIST_SUCCESS, payload: { ...countriesListData } });
        } else {
          // handleError(err);
          dispatch({ type: GET_COUNTRIES_LIST_FAILURE });
          dispatch({
            type: TRIGGER_TOAST,
            payload: {
              shouldShow: true,
              severity : 'error',
              transMessage: "message_errorDefault"
            },
          });
        }
      })
      .catch((err: any) => {
        // handleError(err);
        dispatch({ type: GET_COUNTRIES_LIST_FAILURE });
        dispatch({
          type: TRIGGER_TOAST,
          payload: {
            shouldShow: true,
            severity : 'error',
            transMessage: "message_errorDefault"
          },
        });
      });
  };
};

export default {
  getCountriesList,
};
